import { useMemo } from 'react';
import { useCompetitionsListQuery } from './useCompetitionsListQuery';
import type { CompetitionSummary } from '../types/competitions.types';

/**
 * The row for one competition out of the (cached) hub list — shared by the shell
 * header and the picks screen so both read one query.
 */
export function useCompetitionSummary(competitionId: string): {
  competition: CompetitionSummary | null;
  isPending: boolean;
} {
  const { data, isPending } = useCompetitionsListQuery();
  const competition = useMemo(
    () => data?.find((c) => c.id === competitionId) ?? null,
    [data, competitionId],
  );
  return { competition, isPending };
}

/** Display title for a competition: brand name → plain name. */
export function competitionDisplayTitle(competition: CompetitionSummary | null): string {
  return competition?.brand?.name ?? competition?.name ?? '';
}
